"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var ng_1 = __importDefault(require("core/services/ng"));
require("core/config");
require("core/main");
require("core/services/storage.js");
require("core/services/notify.js");
require("core/services/api.js");
require("core/services/notification.js");
require("core/directives");
require("core/filters");
/* globals __PROFUMO_CONFIG__: true */
var appConfig = __PROFUMO_CONFIG__;
// This module gets overwritten when building for production to create template
// cache. For more information, see the `grunt ngtemplates:core` task.
angular.module('profumo.templates-cache', []);
var core = angular.module('profumo.core', [
    'ngRoute',
    'ngResource',
    'ngSanitize',
    'ui.router',
    'profumo.templates-cache',
    'pathgather.popeye',
    'ui.select',
    '720kb.datepicker',
    'profumo.core.directives',
    'profumo.core.filters',
    'profumo.core.main',
    'profumo.core.storage',
    'profumo.core.notify',
    'profumo.core.api',
    'profumo.notification'
]);
core.constant('lodash', lodash_1.default);
// core.config(['$routeProvider', ($routeProvider) => {
//     $routeProvider.when('/', {
//         redirectTo: appConfig.defaultRoute,
//     });
// }]);
// due to angular 1.6
core.config(['$locationProvider', '$urlRouterProvider', function ($locationProvider, $urlRouterProvider) {
        // $locationProvider.hashPrefix('');
        $locationProvider.html5Mode(false);
        $urlRouterProvider.otherwise('/home');
    }]);
core.config(['$qProvider', function ($qProvider) { return $qProvider.errorOnUnhandledRejections(true); }]);
core.config(['$compileProvider', function ($compileProvider) { return $compileProvider.preAssignBindingsEnabled(true); }]);
core.run(['$injector', ng_1.default.register]);
core.run(['$document', function ($document) {
        if (window.navigator.userAgent.toLowerCase().includes('firefox')) {
            // workaround for firefox drag event not reporting mouse coordinates
            $document.on('dragover', function (event) {
                window.dragPageY = event.pageY;
            });
        }
    }]);
core.config(['uiSelectConfig', function (uiSelectConfig) {
        uiSelectConfig.theme = 'select2';
    }]);
exports.default = core;



//////////////////
// WEBPACK FOOTER
// ./scripts/core/index.ts
// module id = 443
// module chunks = 0